import React, { useState } from 'react'
import DashboardLayout from '../../../../layouts/Dashboard'
import { Button, Col, Spinner, Form, Container, Row, Image } from 'react-bootstrap'
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner'
import api from '../../../../services/api'
import { toast } from 'react-toastify'
import { errorApi } from '../../../../utils/errorApi'
import { useNavigate } from 'react-router-dom'
import { useLoading } from '../../../../hooks/LoadingContext'
import UserCircle from '../../../../assets/UserCircle.svg'

import styles from './styles.module.css'

const AdminNovo: React.FC = () => {
  const [name, setName] = useState<string>('')
  const [sector, setSector] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [password_confirmation, setPassword_confirmation] = useState<string>('')

  const [profilePicture, setProfilePicture] = useState<File | null>()

  const { isLoading, setIsLoading } = useLoading()
  const navigate = useNavigate()

  const clearFileInput = (e: any) => {
    const filesData = new DataTransfer()
    e.target.files = filesData.files
  }

  const handlePictureChange = (e: any) => {
    if (e.target.files) {
      const file = e.target.files[0]
      const fileType = file.name.split('.')[1].toLowerCase()

      if (!['jpg', 'png', 'gif', 'jpeg'].includes(fileType)) {
        toast.error('A foto deve possuir formato .PNG, .JPG, .JPEG ou .GIF')
        clearFileInput(e)
        setProfilePicture(null)
      } else setProfilePicture(e.target.files[0])
    }
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault()

    setIsLoading(true)

    if (!name || !sector || !email || !password || !password_confirmation) {
      toast.error('Você precisa preencher todos os campos obrigatórios!')
      setIsLoading(false)
      return
    }
    if (password !== password_confirmation) {
      toast.error('As senhas devem ser iguais!')
      setIsLoading(false)
      return
    }

    const data = new FormData()
    const model = {
      name,
      sector,
      email,
      password,
      password_confirmation,
    }
    data.append('data', JSON.stringify(model))
    if (profilePicture) data.append('image', profilePicture, profilePicture.name)

    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }

    try {
      await api.post('/admin/admins', data, config)
      toast.info('Administrador cadastrado com sucesso!', {
        autoClose: 3000,
      })
      setIsLoading(false)
      navigate('/admin/admins')
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao cadastrar o administrador! Verifique os dados.'))
      setIsLoading(false)
    }
  }

  const isValidModel = () => {
    return name && sector && email && password && password_confirmation;
  }

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Cadastrar administrador">
      <LoadingSpinner text="Salvando informações. Aguarde..." />
      <Container>
        <h2 style={{ textAlign: 'center' }}>Novo Administrador</h2>
        <Col style={{ textAlign: 'center' }}>
          <Image
            style={{ height: 150, width: 150, borderRadius: 12 }}
            fluid={true}
            src={profilePicture ? URL.createObjectURL(profilePicture) : UserCircle}
          />
        </Col>
        <Col className={styles.form_container}>
          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Nome*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o nome"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Foto de perfil (opcional)
              </Form.Label>
              <Form.Control
                className={styles.input}
                type="file"
                placeholder="Selecione a foto de perfil"
                onChange={(event) => {
                  handlePictureChange(event)
                }}
              />
            </Col>
          </Row>

          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Setor*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o setor"
                value={sector}
                onChange={(event) => setSector(event.target.value)}
              />
            </Col>
          </Row>

          <Row style={{ textAlign: 'left' }}>
            <Col style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                E-mail*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o e-mail"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </Col>
          </Row>
          <Row
            style={{
              paddingBottom: 12,
              textAlign: 'left',
            }}
          >
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Senha*
              </Form.Label>
              <Form.Control
                className={styles.input}
                type="password"
                placeholder="Digite a senha"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Repita a senha*
              </Form.Label>
              <Form.Control
                className={styles.input}
                type="password"
                placeholder="Digite a senha"
                value={password_confirmation}
                onChange={(event) => setPassword_confirmation(event.target.value)}
              />
            </Col>
          </Row>
          <Col style={{ textAlign: 'right' }}>
            <Button
              className={styles.btn_submit}
              disabled={isLoading || !isValidModel()}
              onClick={handleSubmit}
            >
              {isLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    color: '#fff',
                    marginRight: 10,
                  }}
                />
              ) : (
                'Cadastrar administrador'
              )}
            </Button>
          </Col>
        </Col>
      </Container>
    </DashboardLayout>
  )
}

export default AdminNovo
